/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { IVisitor } from '../../../core/visitors/IVisitor';
import { IOas30Visitor } from '../visitors/IOas30Visitor';
import { Oas30Server } from './Oas30Server';

/**
 * Constructor.
 * @class
 * @extends Oas30Server
 * @author eric.wittmann@gmail.com
 */
export class Oas30LinkServer extends Oas30Server {
    public constructor() {
        super();
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.Server#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let viz : IOas30Visitor = <IOas30Visitor><any>visitor;
        viz.visitLinkServer(this);
    }
}
Oas30LinkServer["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30LinkServer";
Oas30LinkServer["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




